export default {
    data: () => ({
        translations: {
            range: {
                el: "",
                en: "Range",
                it: ""
            },
            date: {
                el: "Ημερομηνία",
                en: "Date",
                it: "Data"
            },
            name: {
                el: "Όνομα",
                en: "Name",
                it: "Name"
            },
            streetAddress: {
                el: "Διεύθυνση",
                en: "Street Address",
                it: "Indirizzo"
            },
            productName: {
                el: "Όνομα Προϊόντος",
                en: "Product Name",
                it: "Nome del prodotto"
            },
            bank: {
                el: "Τράπεζα",
                en: "Bank",
                it: "Banca"
            },
            withSubsidy: {
                el: "Με Επιδότηση",
                en: "Subsidised",
                it: "Con sussidio"
            },
            withoutSubsidy: {
                el: "Χωρίς Επιδότηση",
                en: "Not subsidised",
                it: "Senza sussidio"
            },
            payment: {
                el: "",
                en: "Payment",
                it: ""
            },
            storeId: {
                el: "",
                en: "Store ID",
                it: ""
            },
            mid: {
                el: "Mid",
                en: "Mid",
                it: "Mid"
            },
            productCode: {
                el: "Product Code",
                en: "Product Code",
                it: "Product Code"
            },
            paginationText: {
                el: "από",
                en: "of",
                it: "di"
            }
        }
    })
};
